module.exports = __webpack_public_path__ + "img/mobilereportforrepair1.963b9fe4.png";